import { DateFormValues } from 'components/DateFormPanel/DateFormValues';
import { ApiKeyContext } from 'contexts/ApiKeyContext';
import { ReduxState } from 'ducks';
import { logCustomerEventWithNoSideEffects } from 'ducks/client/customerEvents';
import * as React from 'react';
import { useSelector } from 'react-redux';

interface Props {
  guestCount: DateFormValues['guestCount'];
  productInstanceId: DateFormValues['productInstanceId'];
}

export const AnalyticsAvailabilityCheckEventEmitter = ({
  guestCount,
  productInstanceId,
}: Props) => {
  const { apiKey } = React.useContext(ApiKeyContext);
  const visitorToken = useSelector((state: ReduxState) => state.tracking.visitorToken);
  const customerId = useSelector((state: ReduxState) => state.customer.customer?.id);
  const allProductInstances = useSelector((state: ReduxState) => state.productInstances.all);

  const selectedProductInstance = allProductInstances.find((p) => p.id === productInstanceId);

  const stringifiedGuestCount = JSON.stringify(guestCount);

  React.useEffect(() => {
    if (selectedProductInstance?.product_id && selectedProductInstance?.start_date_time_local) {
      const guestCount = JSON.parse(stringifiedGuestCount);
      Object.keys(guestCount).forEach((key) => {
        guestCount[key] = `${guestCount[key]}`;
      });

      const metadata = {
        product_id: selectedProductInstance.product_id,
        date_time: selectedProductInstance.start_date_time_local,
        guest_count: guestCount,
      };

      (async () => {
        // Date form is sensitive to changes in the Redux store so we need
        // to avoid redux dispatch and instead log the customer event directly.
        try {
          await logCustomerEventWithNoSideEffects({
            apiKey,
            eventType: 'check-availability',
            visitorToken,
            metadata: JSON.stringify(metadata),
            customerId: customerId ?? '',
          });
        } catch (err) {
          console.error(err);
        }
      })();
    }
  }, [
    stringifiedGuestCount,
    customerId,
    selectedProductInstance?.product_id,
    selectedProductInstance?.start_date_time_local,
    apiKey,
    visitorToken,
  ]);

  return null;
};
